import { render, staticRenderFns } from "./SiteNotes.vue?vue&type=template&id=f9c45b8c&scoped=true&"
import script from "./SiteNotes.vue?vue&type=script&lang=js&"
export * from "./SiteNotes.vue?vue&type=script&lang=js&"
import style0 from "./SiteNotes.vue?vue&type=style&index=0&id=f9c45b8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c45b8c",
  null
  
)

export default component.exports